module.exports = __webpack_public_path__ + "static/media/icon-spock.b6446e8e.svg";